import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { CoreLink } from '@uncinc/react-drupal-core';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

const NavigationMobileMenuSubItem = ({
  subItem,
  handleLinkClick,
  closeAllModals,
}) => {
  const { t } = useTranslation();
  const subItemHref = subItem.getIn(['link', 'url']);
  const subItemTitle = subItem.getIn(['link', 'title'], '');
  const [isOpen, setOpen] = useState(false);

  const toggleOpen = () => {
    setOpen(!isOpen);
  };

  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : 'unset';
  }, [isOpen]);

  useEffect(() => {
    setOpen(false);
  }, [closeAllModals]);

  return (
    <div key={`menu--main--sub-menu-item-${subItemTitle}:${subItemHref}`}>
      <div className="LegacyNavigationMainMenuMobile--subMenu__item">
        <CoreLink
          className="LegacyNavigationMainMenuMobile--subMenu__items__title"
          to={subItemHref}
        >
          <Container>
            <button type="button" className="LegacyNavigationMainMenu__subMenuPrefix" onClick={toggleOpen}>
              <span>Kennisaanbod op </span>
              <strong>{subItemTitle}</strong>
              <div className="icon icon-chevron-right" />
            </button>
            <div className="divider" />
          </Container>
        </CoreLink>

        <div
          className={`LegacyNavigationMainMenuMobile--subMenu__links ${
            isOpen ? 'mobile--subitem-open' : ''
          }`}
        >
          <Container>
            <button type="button" className="LegacyNavigationMainMenuMobile--submenu__back" onClick={toggleOpen}>
              <div className="icon icon-chevron-right" />
              {t('menu.back')}
            </button>
            <button type="button" className="LegacyNavigationMainMenuMobile--subMenu__items__title" onClick={toggleOpen}>
              <span className="LegacyNavigationMainMenu__subMenuPrefix">
                <span>Kennisaanbod op </span>
                <strong>{subItemTitle}</strong>
              </span>
            </button>

            {subItem.getIn(['subtree']).map((link, index) => {
              const linkHref = link.getIn(['link', 'url']);
              const linkTitle = link.getIn(['link', 'title'], '');

              return (
                <div
                  key={`menu--main--sub-menu-item-${linkTitle}:${linkHref}`}
                  className="LegacyNavigationMainMenuMobile--subMenu__link"
                >
                  <CoreLink
                    className="LegacyNavigationMainMenuMobile--subMenu__link__title"
                    to={linkHref}
                    onClick={() => {
                      handleLinkClick();
                      toggleOpen();
                    }}
                  >
                    {linkTitle}
                    <div className="icon icon-chevron-right icon-variant-0" />
                  </CoreLink>
                </div>
              );
            })}
            <div
              className="LegacyNavigationMainMenuMobile--submenu__back"
              onClick={toggleOpen}
            >
              <div className="icon icon-chevron-right" />
              {t('menu.back')}
            </div>
          </Container>
        </div>
      </div>
    </div>
  );
};

export default NavigationMobileMenuSubItem;
